"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.youTubeVideoUrlToId = void 0;
const youTubeVideoUrlToId = (url) => {
    var _a;
    const id = (_a = url.match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/)) === null || _a === void 0 ? void 0 : _a[1];
    if (!id)
        throw new Error(`Could not find YouTube ID in URL: ${url}`);
    return id;
};
exports.youTubeVideoUrlToId = youTubeVideoUrlToId;
